<template>
  <div>
    <div class='footer-ru-licence_wrapper'>
    <RouterLink to="/rules" class="footer_link">{{ $t('Правила Программы "Карта Леста от Т-Банка"') }}<LinkIcon /></RouterLink>
    <a target="_blank" href="https://lesta.ru/support/ru/products/lgc/article/36991/" class="footer_link">{{ $t('Архив Правил Программы "Карта Леста от Т-Банка"') }}<LinkIcon /></a>
    </div>
    <p v-html="license"></p>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import LinkIcon from '@/common/components/Decoration/LinkIcon'

const ERID_GAME_CODES = {
  mt: '2RanykKUfz9',
  mk: '2RanynGGscd',
  tb: '2Ranyk9AYBT'
}

@Component({
  components: {
    LinkIcon
  }
})
class LicenseRu extends Vue {
  @Prop({ type: Number }) year

  get eridCode () {
    const game = this.$route.params.slug || ''

    return ERID_GAME_CODES[game] || ''
  }

  get license () {
    if (this.eridCode.length === 0) {
      return ''
    }

    return `Реклама. АО «ТБАНК». ИНН 7710140679 <br /> Erid: ${this.eridCode}`
  }
}

export default LicenseRu
</script>
<style>
.footer-ru-licence_wrapper{
  display:flex;
  flex-direction:column;
}
</style>
